import React from 'react';
import { FadeIn } from './FadeIn';
export function TestimonialsBig() {
  const testimonials = [{
    initials: 'MR',
    name: 'María Rosa',
    location: 'Buenos Aires',
    role: 'Profesora particular, 22 alumnos',
    quote: 'Compré un domingo a la noche. El lunes tenía todo el año pianístico organizado. Las flashcards del Tomo 2 son lo que necesitaba para mis alumnos chicos. Ya no improviso nada.'
  }, {
    initials: 'JC',
    name: 'Jorge Carrizo',
    location: 'Rosario',
    role: 'Profesor en Conservatorio + clases particulares',
    quote: "Las 40 ideas de juegos del Tomo 3 me cambiaron la forma de enseñar teoría. El primer mes, tres alumnos que odiaban el solfeo ahora me piden 'el juego del dictado'. Increíble."
  }, {
    initials: 'SV',
    name: 'Sofía Velasco',
    location: 'Córdoba',
    role: 'Profesora independiente, 35 alumnos',
    quote: "El sistema de repertorio del Tomo 4 me ahorró meses de búsqueda. El mapa 'si le gustó X, dale Y' es magia. En 30 segundos elijo la próxima pieza para cada alumno con criterio."
  }, {
    initials: 'FL',
    name: 'Fernando López',
    location: 'Tucumán',
    role: 'Profesor particular y academia',
    quote: "Implementé la 'ronda de logros' trimestral del Tomo 6 y los padres dejaron de preguntar 'cuándo va a tocar algo'. Ahora ven concretamente cómo avanza su hijo. La retención subió muchísimo."
  }, {
    initials: 'LP',
    name: 'Laura Pérez',
    location: 'Mendoza',
    role: 'Profesora de adultos',
    quote: 'Mi tasa de retención pasó del 50% al 90%. Sin cambiar técnicamente lo que enseño. Solo aplicando el sistema de comunicación con familias del Tomo 6 y los honorarios del Bono 5. En 6 meses subí los precios un 35%.'
  }, {
    initials: 'VT',
    name: 'Valeria Tognoni',
    location: 'Santa Fe',
    role: 'Profesora online + presencial',
    quote: "Ahora entrego el reporte trimestral profesional a las familias y el cuaderno del alumno. Los padres me ven distinto. Una mamá me dijo: 'parece que hubieras hecho un curso, ¿no?'. Le dije que sí."
  }, {
    initials: 'AR',
    name: 'Ana Ramírez',
    location: 'Salta',
    role: 'Profesora con 8 años de experiencia',
    quote: "El Tomo 5 de técnica me dio el lenguaje claro que me faltaba. Antes les decía 'soltá la mano' y no entendían. Ahora les explico el peso del brazo con la metáfora del tomo. Cambia todo."
  }, {
    initials: 'RT',
    name: 'Roberto Tapia',
    location: 'Neuquén',
    role: 'Profesor y pianista de tango',
    quote: "Las 30 piezas de películas del Bono 1 son oro. Mis alumnos adultos nunca habían tenido tanto repertorio que reconocían. Ahora me piden 'una pieza más' y les paso lo siguiente del banco."
  }, {
    initials: 'CM',
    name: 'Carolina Méndez',
    location: 'Entre Ríos',
    role: 'Profesora rural',
    quote: 'Organicé mi primer recital con el Tomo 6. 14 alumnos. Los padres lloraron. Una abuela me agradeció en el escenario. Antes nunca me había animado. Ahora hago dos por año.'
  }];
  return <section className="bg-warmWhite py-24 border-t border-gray-200" data-id="element-259">
      <div className="container mx-auto px-6" data-id="element-260">
        <FadeIn className="text-center mb-16" data-id="element-261">
          <h2 className="font-display font-bold text-4xl md:text-5xl text-navy-900 mb-4" data-id="element-262">
            Lo que dicen los profes que ya lo usan:
          </h2>
          <p className="font-accent italic text-xl md:text-2xl text-gray-600" data-id="element-263">
            +250 profesores de piano de todo el país ya tienen su Piano Listo
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto" data-id="element-264">
          {testimonials.map((t, i) => <FadeIn key={i} delay={0.1 * (i % 3)} direction="up" data-id="element-265">
              <div className="bg-cream p-6 rounded-xl shadow-sm border border-gray-200 h-full flex flex-col relative overflow-hidden group hover:shadow-md transition-all" data-id="element-266">
                {/* Gold accent corner */}
                <div className="absolute top-0 right-0 w-16 h-16 bg-gold/10 rounded-bl-full -mr-8 -mt-8 group-hover:bg-gold/20 transition-colors" data-id="element-267"></div>

                <div className="flex items-center gap-3 mb-4 relative z-10" data-id="element-268">
                  <div className="w-10 h-10 rounded-full bg-navy-800 text-gold flex items-center justify-center font-bold text-sm border border-gold/30 shrink-0" data-id="element-269">
                    {t.initials}
                  </div>
                  <div data-id="element-270">
                    <div className="flex text-gold text-xs mb-1" data-id="element-271">
                      ⭐⭐⭐⭐⭐
                    </div>
                    <h4 className="font-bold text-navy-900 leading-tight" data-id="element-272">
                      {t.name}
                    </h4>
                  </div>
                </div>

                <p className="text-xs text-gray-500 italic mb-4 pb-4 border-b border-gray-200 relative z-10" data-id="element-273">
                  📍 {t.location} | {t.role}
                </p>

                <p className="text-gray-700 text-sm leading-relaxed flex-grow relative z-10" data-id="element-274">
                  "{t.quote}"
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}